import React from "react";
import {
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Tooltip,
  Typography,
  Box,
} from "@material-ui/core";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import { useStyles } from "./ReleaseNotesForm.styles";

const ReleaseNotesForm = ({
  settings,
  onChange,
  onBlur,
  dateError,
  fieldErrors,
}) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.root} release-notes-form`} data-testid="release-notes-form">
      <Grid container spacing={2}>
        {/* Release Notes Section */}
        <Grid item xs={12} className={classes.section}>
          <Typography variant="h6">Release Notes</Typography>
        </Grid>

        <Grid item xs={12} className={classes.field}>
          <FormControlLabel
            className="release-notes-enabled-toggle"
            control={
              <Switch
                color="primary"
                checked={settings.releaseNotesEnabled || false}
                onChange={(e) =>
                  onChange("releaseNotesEnabled", e.target.checked)
                }
                data-testid="release-notes-enabled-toggle"
              />
            }
            label="Enable Release Notes Notice"
          />
        </Grid>

        <Grid item xs={12} className={classes.field}>
          <TextField
            className="release-notes-url-field"
            label="Release Notes URL"
            value={settings.releaseNotesUrl || ""}
            onChange={(e) => onChange("releaseNotesUrl", e.target.value, false)}
            onBlur={() => onBlur("releaseNotesUrl")}
            fullWidth
            variant="outlined"
            inputProps={{ maxLength: 2048 }}
            error={!!fieldErrors?.releaseNotesUrl}
            helperText={fieldErrors?.releaseNotesUrl || ""}
            data-testid="release-notes-url-field"
          />
        </Grid>

        <Grid item xs={12} sm={6} className={classes.field}>
          <KeyboardDateTimePicker
            className="display-from-picker"
            label="Display From"
            value={settings.displayFrom || null}
            onChange={(date) => onChange("displayFrom", date)}
            format="MM/DD/YYYY hh:mm a"
            fullWidth
            inputVariant="outlined"
            clearable
            error={!!dateError}
            helperText={dateError || ""}
            data-testid="display-from-picker"
          />
        </Grid>

        <Grid item xs={12} sm={6} className={classes.field}>
          <KeyboardDateTimePicker
            className="display-to-picker"
            label="Display To"
            value={settings.displayTo || null}
            onChange={(date) => onChange("displayTo", date)}
            format="MM/DD/YYYY hh:mm a"
            fullWidth
            inputVariant="outlined"
            clearable
            data-testid="display-to-picker"
          />
        </Grid>

        {/* Feedback Section */}
        <Grid item xs={12} className={classes.section}>
          <Typography variant="h6">Feedback</Typography>
        </Grid>

        <Grid item xs={12} className={classes.field}>
          <FormControlLabel
            className="feedback-enabled-toggle"
            control={
              <Switch
                color="primary"
                checked={settings.feedbackEnabled || false}
                onChange={(e) =>
                  onChange("feedbackEnabled", e.target.checked)
                }
                data-testid="feedback-enabled-toggle"
              />
            }
            label="Enable Feedback Button"
          />
        </Grid>

        <Grid item xs={12} className={classes.field}>
          <TextField
            className="feedback-link-field"
            label="Feedback Link"
            value={settings.feedbackLink || ""}
            onChange={(e) => onChange("feedbackLink", e.target.value, false)}
            onBlur={() => onBlur("feedbackLink")}
            fullWidth
            variant="outlined"
            inputProps={{ maxLength: 2048 }}
            error={!!fieldErrors?.feedbackLink}
            helperText={fieldErrors?.feedbackLink || ""}
            data-testid="feedback-link-field"
          />
        </Grid>

        <Grid item xs={12} sm={6} className={classes.field}>
          <Tooltip title="Limited to 25 characters">
            <TextField
              className="feedback-button-label-field"
              label="Button Label"
              value={settings.feedbackButtonLabel ?? "Feedback"}
              onChange={(e) => onChange("feedbackButtonLabel", e.target.value, false)}
              onBlur={() => onBlur("feedbackButtonLabel")}
              fullWidth
              variant="outlined"
              inputProps={{ maxLength: 25 }}
              error={!!fieldErrors?.feedbackButtonLabel}
              helperText={fieldErrors?.feedbackButtonLabel || ""}
              data-testid="button-label-field"
            />
          </Tooltip>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReleaseNotesForm;
